import { uid } from "quasar";

export const setCatList = (state, reqResponse) => {
    state.items = reqResponse.data.data ? reqResponse.data.data : [];
    if (!state.items.length) {
        state.commitId = null;
        state.masterId = null;
    }
    if (reqResponse.payload) {
        state.dataFromImport = reqResponse.data.data;
    }
};

export const setDataModelList = (state, payload) => {
    state.dataModelList = payload;
};

export const setCurrApp = (state, payload) => {
    state.currApp = payload;
};

export const setFromCatList = (state, payload) => {
    state.fromCatList = payload;
};

export const setDeleteCatAction = (state, payload) => {
    state.deleteCatAction = payload;
};

export const setCatalogsAlreadySaved = (state, payload) => {
    state.catalogsAlreadySaved = payload;
};

export const setNewCatalog = (state, payload) => {
    state.newCatalog = payload;
};

export const addCatalog = (state, payload) => {
    state.items.push(payload);
    state.items.sort((firstFeature, secondFeature) => firstFeature.name.localeCompare(secondFeature.name));
};

export const modifyDescription = (state, payload) => {
    for (let i = 0; i < state.items.length; i++) {
        if (payload.selectedCatName === state.items[i].name) {
            state.items[i].description = payload.newDescription;
            break;
        }
    }
};
export const addColumnsToCatalog = (state, payload) => {
    state.selectedCatalogData.fields.push(...payload.columns);
};
export const removeColumnsFromCatalog = (state, payload) => {
    state.selectedCatalogData.fields = state.selectedCatalogData.fields.filter(column => payload.columns.indexOf(column.name) === -1);
};
export const deleteCurrentlySelectedCatalog = state => {
    // if (state.selectedCat.name) {
    //     let stateItem = state.items.find(item => item.name === state.selectedCat.name);
    //
    //     if (stateItem) {
    //         stateItem.removed = true;
    //         state.unsavedChanges.some(item => {
    //             let test = false;
    //             if (item.name === stateItem) {
    //                 item.active = false;
    //                 test = true;
    //             }
    //
    //             return test;
    //         })
    //     }
    // }

    let catName = "";
    state.deleteCatAction = true;
    // state.items = state.items.filter((cat) => cat.name !== state.selectedCat.name);
    for (let i = 0; i < state.items.length; i++) {
        if (state.items[i].name === state.selectedCat.name) {
            state.items[i].removed = true;
            catName = state.items[i].name;
            break;
        }
    }
    for (let i = 0; i < state.selectedCatalogData.length; i++) {
        if (state.selectedCatalogData[i].type === catName) {
            state.selectedCatalogData[i].active = false;
        }
    }
    for (let i = 0; i < state.unsavedChanges.length; i++) {
        if (state.unsavedChanges[i].type === catName) {
            state.unsavedChanges[i].active = false;
        }
    }
};

export const expCatListXls = (state, reqResponse) => {
    /// get file name
    let fileName = "";
    if (reqResponse.fileName.length > 1) {
        fileName = `${state.currApp.name}-export.xlsx`;
    } else {
        fileName = `${reqResponse.fileName[0]}-export.xlsx`;
    }

    const blob = new Blob([reqResponse.data], {
        type: reqResponse.headers["content-type"],
        responseType: "arraybuffer"
    });
    const downloadUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
    }, 0);
};

export const expCatListJsn = (state, reqResponse) => {
    let filename;
    const fileType = "text/plain";
    const fileNameType = "-export.json";
    // eslint-disable-next-line no-restricted-globals
    const exportObj = { catalogs: self.initialobj, data: reqResponse.data };

    const file = new Blob([JSON.stringify(exportObj)], { type: fileType });
    if (state.fromCatList) {
        filename = state.currApp.name + fileNameType;
    } else {
        filename = state.selectedCat.name ? state.selectedCat.name + fileNameType : reqResponse.fileName + fileNameType;
    }

    if (window.navigator.msSaveOrOpenBlob) {
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
    } else {
        // Others
        const a = document.createElement("a");
        const url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
    }
};
export const persistCatalogModelChange = (state, payload) => {
    state.selectedCatalogData = payload.data;
};

export const setItems = (state, payload) => {
    state.items = payload;
};

export const setInEditCatalogColumns = (state, payload) => {
    state.inEditCatalogColumns = payload;
};

export const setColumns = (state, payload) => {
    state.columns = payload;
};

export const setColumnsForDataDisplay = (state, payload) => {
    state.columnsForData = payload;
};

export const setTemporaryColumnsCache = (state, payload) => {
    let data = [];
    if (payload) {
        data = Object.assign(
            [],
            payload.map(col => {
                if (!col.uuid) {
                    col.uuid = uid();
                }
                return { ...col };
            })
        );
    }
    state.temporaryColumnsCache = data;
};

export const setUpdatedCatalogData = (state, payload) => {
    state.selectedCatalogData = payload;
};

export const setSelectedCat = (state, payload) => {
    state.selectedCat = payload;
};

export const setFieldsSelectedCat = (state, payload) => {
    state.selectedCat.fields = payload;
};

export const setSelectedCatalogData = (state, payload) => {
    state.selectedCatalogData = payload;
};

export const setDataFromImport = (state, payload) => {
    state.dataFromImport = payload;
};

export const setFromImportExcel = (state, payload) => {
    state.fromImportExcel = payload;
};

export const setUnsavedChanges = (state, payload) => {
    state.unsavedChanges = payload;
};

export const addTemporaryColumn = (state, payload) => {
    payload.uuid = uid();
    payload.delete = false;
    state.temporaryColumnsCache.push(payload);
};
export const setTableDetails = (state, reqResponse) => {
    if (reqResponse.data) {
        state.selectedCatalogData = reqResponse.data;
    } else {
        state.selectedCatalogData.data = reqResponse;
    }
    for (let i = 0; i < state.selectedCatalogData.data.length; i++) {
        Object.keys(state.selectedCatalogData.data[i].columns).forEach(key => {
            if (typeof state.selectedCatalogData.data[i].columns[key] === "object") {
                state.selectedCatalogData.data[i].columns[key] = state.selectedCatalogData.data[i].columns[key][0].value;
            }
        });
    }
};
export const setMasterId = (state, payload) => {
    state.masterId = payload;
};
export const setCommitId = (state, payload) => {
    state.commitId = payload;
};
